define( function() {
	"use strict";

	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/location.js
// module id = 258
// module chunks = 0